/**
 * Phase 35 — the container's judged history (its campaign group's for a
 * master config): read once per editor opening, zero writes.
 * For Media Devoted | Created By Ciro Autiero
 */
import { useQuery } from '@tanstack/react-query';
import type { DropGenHistory } from '@trafficpulse/shared';

import { api } from '@/services/api';

export const HISTORY_DAYS = 30;

/** Under the Drop Generator root key, so every mutation's invalidate refreshes it too. */
export const historyKey = (countryKey: string, id: string | null, days: number) => ['drop-generator', 'history', countryKey, id ?? 'none', days] as const;

export function useVerdictHistory(countryKey: string, id: string | null, days = HISTORY_DAYS) {
  return useQuery({
    queryKey: historyKey(countryKey, id, days),
    queryFn: async () => {
      const res = await api.get<{ data: DropGenHistory }>(`/drop-generator/verdicts/${countryKey}/containers/${id}/history`, { params: { days } });
      return res.data.data;
    },
    enabled: id !== null,
    staleTime: 60_000,
  });
}
